'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cbWaitingTime = require('./cb-waiting-time.directive');

var _cbWaitingTime2 = _interopRequireDefault(_cbWaitingTime);

var _cbWaitingTime3 = require('./cb-waiting-time.controller');

var _cbWaitingTime4 = _interopRequireDefault(_cbWaitingTime3);

var _waitingTime = require('./waiting-time.constants');

var _waitingTime2 = _interopRequireDefault(_waitingTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('cb.ui-components.waiting-time', ['cb.webApi', 'cb.util']).directive('cbWaitingTime', _cbWaitingTime2.default).controller('cbWaitingTimeController', _cbWaitingTime4.default).constant('waitingTimeConstants', _waitingTime2.default);

exports.default = _module;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/waiting-time/index.js
// module id = 927
// module chunks = 0